exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-breadcrumb .breadcrumb {\n  flex-wrap: nowrap;\n  padding: 0.2rem 0.3rem;\n  margin-bottom: 0.5rem;\n}\n.fm-breadcrumb .breadcrumb.active-manager {\n  background-color: #c2e5eb;\n}\n.fm-breadcrumb .breadcrumb .breadcrumb-item:not(.active):hover {\n  cursor: pointer;\n  font-weight: normal;\n  color: #6d757d;\n}", ""]);

// exports
